import React, { createContext, useContext, useEffect, useLayoutEffect, useState } from 'react';
import api from '../utils/api';

export const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
	const [token, setToken] = useState();
	const [loading, setLoading] = useState(true);
	const [user, setUser] = useState(null);

	const setTokenAndUser = async (newToken) => {
        setToken(newToken);
        if (newToken) {
            await fetchMe(newToken);
        } else {
            setUser(null);
        }
    };

const fetchMe = async (tokenToUse = token) => {
    try {
        const response = await api.get('/me', {
            headers: { Authorization: `Bearer ${tokenToUse}` }
        });
        setUser(response.data.user);
    } catch (error) {
        setUser(null);
    }
};

	// Try to refresh token on mount
	useEffect(() => {
		const tryRefresh = async () => {
			try {
				const response = await api.get('/refreshToken', { 
				withCredentials: true 
				});
				setToken(response.data.accessToken);
			} catch (error) {
				setToken(null);
			} finally {
				setLoading(false);
			}
		};
		tryRefresh();
	}, []);

	// Fetch user data when token changes
	useEffect(() => {
		if (!token) {
		setUser(null);
		return;
		}

		fetchMe(token);
	}, [token]);

		useLayoutEffect(() => {
			const authInterceptor = api.interceptors.request.use((config) => {
				config.headers.Authorization =
					!config._retry && token
						? `Bearer ${token}`
						: config.headers.Authorization;
				return config;
			})

			return () => {
				api.interceptors.request.eject(authInterceptor);
			}
		}, [token]);

		useLayoutEffect(() => {
			const refreshInterceptor = api.interceptors.response.use(
				(response) => response,
				async (error) => {
					const originalRequest = error.config;

					if (
						(error.response.status === 401 || error.response.status === 403) &&
						error.response.data.message === 'Unauthorized'
					) {
						console.log('Refreshing token...');
						try {
							const response = await api.get('/refreshToken', { withCredentials: true });

							console.log('Token refreshed:', response.data.accessToken);
							setToken(response.data.accessToken);

							originalRequest.headers.Authorization = `Bearer ${response.data.accessToken}`;
							originalRequest._retry = true;

							return api(originalRequest);
						} catch {
							console.error('Failed to refresh token:', error);
							setToken(null);
						}
					}

					return Promise.reject(error);
				},
			);

			return () => {
				api.interceptors.response.eject(refreshInterceptor);
			}
		})

		return (
			<AuthContext.Provider value={{ token, setToken, setTokenAndUser, user, loading }}>
				{children}
			</AuthContext.Provider>
		);
}

export default AuthProvider